class Retencion {
    constructor(idLiquidacionDetalleRetencion,pyid,nroFactura,nroDocumento,fechaComprobante,alicuota,nroOrden,cuit,fechaPago,montoFactura,montoPorLinea,montoPorLineaRetencion,montoRetencionIIBB,sujetoRetenido,tipoRetencion){
      this.idLiquidacionDetalleRetencion=idLiquidacionDetalleRetencion
      this.pyid=pyid
      this.nroFactura=nroFactura
      this.nroDocumento=nroDocumento
      this.nroOrden=nroOrden
      this.cuit=cuit
      this.fechaPago=fechaPago
      this.montoFactura=montoFactura
      this.montoPorLinea=montoPorLinea
      this.montoPorLineaRetencion=montoPorLineaRetencion
      this.sujetoRetenido=sujetoRetenido
      this.tipoRetencion=tipoRetencion
      this.fechaComprobante=fechaComprobante
      this.alicuota=alicuota
      this.montoRetencionIIBB=montoRetencionIIBB
    }
  }
  
  export default Retencion
  